import React, { ReactElement } from "react"
import { FormLabel } from "@wfp/ui"
import Select from "react-select"
import { FieldsData, HeadersSheet } from "interfaces/mappingInterfaces"

type Props = {
  surveyList?: HeadersSheet[]
  choiceList?: HeadersSheet[]
  values: FieldsData
  setValues: React.Dispatch<React.SetStateAction<FieldsData>>
}

const XlsFormFieldMapping = ({ surveyList, choiceList, setValues, values }: Props): ReactElement => {
  return (
    <>
      <div>
        <FormLabel htmlFor="survey">Select question label (English recommended)</FormLabel>
        <Select
          inputId="survey"
          placeholder="Select survey label"
          isClearable
          options={surveyList ?? []}
          getOptionLabel={option => option.text}
          getOptionValue={option => option.position.toString()}
          value={surveyList?.find(survey => Number(survey.position) === values.questionLabelPosition) ?? null}
          onChange={item => setValues({ ...values, questionLabelPosition: item?.position ?? 0 })}
          menuPlacement="auto"
        />
      </div>
      <div className="mt-2">
        <FormLabel htmlFor="choice">Select choice label (English required)</FormLabel>
        <Select
          inputId="choice"
          placeholder="Select choice label"
          isClearable
          options={choiceList ?? []}
          getOptionLabel={option => option.text}
          getOptionValue={option => option.position.toString()}
          value={choiceList?.find(choice => Number(choice.position) === values.choiceLabelPosition) ?? null}
          onChange={item => setValues({ ...values, choiceLabelPosition: item?.position ?? 0 })}
          menuPlacement="auto"
        />
      </div>
    </>
  )
}

export default XlsFormFieldMapping
